import { fetchWithSession } from "../../../../lib/util/fetchWithSession";
import { projectListStore } from "@stores/damProjectsStore.js";
import { PROJECT_STAGES } from "@utils/stagesAndSteps.js";

// Review progress over both anonymization check pages, counted on all entries of the stage:
// the assigned ones and those of recordings without an L4 ("Unassigned"), because both reach
// the analysis. Users can only complete the check once task registration has ended, so no new
// entries arrive afterwards, and window titles and UI elements are fully checked.

// Pseudo L4 for entries of recordings without an L4.
export const UNASSIGNED_SUBTASK = { id: "unassigned", name: "Unassigned" };

async function countChecked(url) {
  const response = await fetchWithSession(url);
  const data = await response.json();
  if (!response.ok) throw new Error(data?.error || "Unable to load review progress");
  const rows = data.rows || [];
  return {
    checked: rows.filter((row) => row.checked).length,
    total: rows.length,
  };
}

export async function loadAnonymizationCheckProgress(projectStageId, idproject) {
  const query = `project_stage_id=${projectStageId}&scope=global`;
  const [windowTitles, uiElements, registrationEnded, checkCompleted] = await Promise.all([
    countChecked(`/api/damprojects/anonymization-assistant-preview-scoped?${query}`),
    countChecked(`/api/damprojects/ui-element-anonymization-preview-scoped?${query}`),
    projectListStore.isStepCompleted(
      idproject,
      PROJECT_STAGES.TASK_REGISTRATION.steps.END_TASK_REG,
      PROJECT_STAGES.TASK_REGISTRATION.id,
    ),
    projectListStore.isStepCompleted(
      idproject,
      PROJECT_STAGES.TASK_REGISTRATION.steps.CHECK_ANON,
      PROJECT_STAGES.TASK_REGISTRATION.id,
    ),
  ]);
  // One number for the header: the same entries that decide whether the step can be completed.
  const checked = windowTitles.checked + uiElements.checked;
  const total = windowTitles.total + uiElements.total;
  return {
    checked,
    total,
    // Shown on the disabled "Complete Anonymization Check" button.
    blockedReason: !registrationEnded
      ? "Available once task registration has ended."
      : checked < total
        ? `${total - checked} ${total - checked === 1 ? "entry is" : "entries are"} still open.`
        : "",
    // Per level, for the hint that points to the level that is still open.
    windowTitles,
    uiElements,
    registrationEnded,
    checkCompleted,
    complete: registrationEnded && checked === total,
  };
}
